import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import b_ from 'b_';
import { UrlListStore } from '../../stores/BrowserPolicies/ContentFilteringStore';
import Modal from '../Modal';
import Box from '../Box/Box';
import Button from '../Button';
import UrlPatternInput from '../UrlPatternInput/UrlPatternInput';
import './AddEditUrlModal.css';

const block = b_.lock('AddEditUrlModal');

class AddEditUrlModal extends Component {
    static propTypes = {
        urlList: UrlListStore.PropType.isRequired,
        inputLabel: PropTypes.string,
    };

    onSubmit = (event) => {
        event.preventDefault();
        if (this.props.urlList.canSubmit()) {
            this.props.urlList.saveModalChanges();
        }
    };

    render() {
        const { urlList, inputLabel } = this.props;
        const { modal, isModalEditing, modalTextField, urlGuidelines } = urlList;

        return <Modal
            isOpen={modal.isOpen}
            overlayClassName={block('Overlay')}
            className={block('Content')}
            onAfterOpen={modalTextField.focus}
        >
            <Box title={isModalEditing ? 'Edit URL' : 'Add New URL'}>
                <form onSubmit={this.onSubmit}>
                    <UrlPatternInput
                        className={block('UrlPatternInput')}
                        inputStore={modalTextField}
                        inputLabel={inputLabel}
                        guidelines={urlGuidelines}
                    />
                    <div className={block('Controls')}>
                        <Button
                            className={block('ControlsItem')}
                            raised
                            secondaryWhite
                            onClick={modal.close}
                        >Cancel</Button>
                        <Button
                            className={block('ControlsItem')}
                            type="submit"
                            raised
                            primaryGreen
                            disabled={!urlList.canSubmit()}
                        >Save</Button>
                    </div>
                </form>
            </Box>
        </Modal>;
    }
}

export default observer(AddEditUrlModal);
